<template>
  <div v-resize="onResize">
    <v-toolbar dense flat color="secondary darken-1">
      <v-layout
        style="margin-top: 20px"
        align-center
        justify-start
        row
        fill-height
      >
        <v-switch
          v-show="!isTable"
          style="max-width: 220px"
          v-model="useMapExtent"
          color="blue"
          label="Begrens til kartutsnitt"
        ></v-switch>

        <v-switch
          v-show="$vuetify.breakpoint.mdAndUp && !isTable"
          style="max-width: 200px"
          v-model="zoomToSelected"
          color="blue"
          label="Panorer til valgt rad"
        ></v-switch>
      </v-layout>
      <v-spacer></v-spacer>

      <v-menu offset-y>
        <template #activator="{ on: menu }">
          <v-tooltip bottom>
            <template #activator="{ on: tooltip }">
              <v-btn
                flat
                color
                class="mr-0"
                :disabled="selected.length === 0"
                v-on="{ ...tooltip, ...menu }"
              >
                <v-icon class="pr-2" small>mdi-file-download-outline</v-icon
                >Eksporter
              </v-btn>
            </template>
            <span>Eksporter selekterte elementer</span>
          </v-tooltip>
        </template>

        <v-list>
          <v-list-tile
            v-for="(item, i) in exportOptions"
            :key="i"
            @click="exportData(item.format)"
          >
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-layout column fill-height>
      <v-data-table
        v-model="selected"
        select-all
        :headers="headers"
        :items="features"
        :pagination.sync="pagination"
        no-data-text="Ingen data tilgjengelig"
        :rows-per-page-items="rowsPerPageItems"
        item-key="attributes.OBJECTID"
        :total-items="totalItems"
        :loading="loading"
        class="fixed-header v-table__overflow"
        :style="{ height: tableHeight + 'px' }"
      >
        <template v-slot:items="props">
          <tr
            :active="
              props.selected ||
              props.item.attributes.OBJECTID === currentlySelectedRowObjectId
            "
            @click="select(props.item)"
          >
            <td>
              <v-checkbox
                color="blue"
                v-model="props.selected"
                primary
                hide-details
              ></v-checkbox>
            </td>
            <td v-for="header in headers" :key="header.text">
              {{
                header.domain
                  ? getCodedValue(
                      header.domain,
                      props.item.attributes[header.value]
                    )
                  : getItemValue(props.item.attributes,header)
              }}
            </td>
          </tr>
        </template>

        <template v-slot:pageText="props"
          >Rader: {{ props.pageStart }} - {{ props.pageStop }} av
          {{ props.itemsLength }}</template
        >
      </v-data-table>
    </v-layout>
  </div>
</template>

<script>
import TableService from "@/services/table.service";
import { mapState, mapActions } from "vuex";
import MappingMixin from "@/mixins/mappingMixin";
import ExtractMixin from "@/mixins/extractMixin";
export default {
  name: "LayerTable",
  mixins: [MappingMixin, ExtractMixin],
  data: function () {
    return {
      totalItems: 0,
      useMapExtent: false,
      zoomToSelected: false,
      rowsPerPageItems: [10, 25, 50, 100, 200, 500, 1000],
      features: [],
      currentlySelectedRowObjectId: null,
      loading: true,
      selected: [],
      windowSize: {
        x: 0,
        y: 0,
      },
      pagination: {
        rowsPerPage: 50,
      },
      headers: [],
      restAdress: "",
      restIndex: "",
    };
  },
  props: {
    layer: Object,
    isTable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(["extent", "bottomTabsHeight"]),
    metadata() {
      // if (this.isTable) {
      //   return null;
      // } else {
      return this.$store.getters["getLayerMetadataByAddressAndIndex"](
        this.layer.url.replace(/(^\w+:|^)\/\//, ""),
        this.layer.id
      );
      // }
    },
    exportOptions() {
      if (this.isTable) {
        return [
          {
            title: "CSV",
            format: "csv",
          },
        ];
      } else {
        return [
          {
            title: "CSV",
            format: "csv",
          },
          {
            title: "KMZ",
            format: "kmz",
          },
          {
            title: "JSON",
            format: "json",
          },
          {
            title: "GeoJSON",
            format: "geojson",
          },
          {
            title: "Shape",
            format: "shape",
          },
        ];
      }
    },
    layerInfo() {
      // if (this.isTable) {
      //   return null;
      // } else {
      return this.$store.getters["getLayerInfoByUrl"](
        this.layer.url + "/" + this.layer.id
      );
      // }
    },
    tableHeight() {
      return (this.windowSize.y / 100) * this.bottomTabsHeight - 100;
    },
  },
  methods: {
    ...mapActions(["setSnack", "setSelectedExtent"]),
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
    getItemValue(attributes,header) {
      if (header.type === "esriFieldTypeDate" && attributes[header.value]) {
        return new Date(attributes[header.value]).toLocaleDateString("nb-NO");
      }
      return attributes[header.value];
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.features.slice();
    },
    select(selectedItem) {
      this.currentlySelectedRowObjectId = selectedItem.attributes.OBJECTID;
      this.features.forEach((item) => {
        if (item.attributes.OBJECTID == selectedItem.attributes.OBJECTID) {
          if (this.zoomToSelected) {
            this.zoomToGeometry(item.geometry);
          }
        }
      });
    },
    exportData(format) {
      if (format === "csv") {
        this.downloadGraphicsAsCSVFile(this.headers, this.selected);
      } else if (format === "shape") {
        this.downloadGraphicsAsShapeFile(this.selected);
      } else {
        this.downloadGraphicsAsOtherFormat(this.selected, format);
      }
    },
    async zoomToGeometry(geometryJson) {
      let geometry = await this.getValidGeometry(geometryJson);

      this.setSelectedExtent(geometry);
    },
    updateHeaders(layerInfo) {
      if (this.layer.hasOwnProperty("columns")) {
        if (this.headers.length === 0) {
          this.layer.columns.forEach((column) => {
            this.headers.push(column);
          });
        }
      } else {
        if (
          layerInfo &&
          layerInfo.fields !== null &&
          this.headers.length == 0
        ) {
          layerInfo.fields.forEach((felt) => {
            if (
              felt.alias === "OBJECTID" ||
              felt.alias.toLowerCase() === "shape" ||
              felt.alias === "GlobalID"
            ) {
              return;
            }
            this.headers.push({
              text: felt.alias,
              value: felt.name,
              domain: felt.domain,
              type: felt.type,
            });
          });
        }
      }
    },
    getDataFromApi() {
      this.loading = true;

      let theMapLayer;

      if (this.isTable) {
        let outFields = [];

        if (this.layer.hasOwnProperty("columns")) {
          this.layer.columns.forEach((column) => {
            outFields.push(column.value);
          });
        } else {
          outFields.push("*");
        }

        let expressionValue = this.layer.value;
        if (
          this.layer.hasOwnProperty("keyIsString") &&
          this.layer.keyIsString
        ) {
          expressionValue = "'" + expressionValue + "'";
        }
        theMapLayer = {
          definitionExpression: this.layer.key + " = " + expressionValue,
          outFields: outFields,
        };
      } else {
        theMapLayer = this.$theMapObject
          .findLayerById(this.layer.parentLayerID) // HER
          .allSublayers.items.find((sl) => {
            return sl.id == this.layer.id;
          });
      }

      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        let resultOffset = (page - 1) * rowsPerPage;
        let params = this.getQueryParams(theMapLayer);
        TableService.queryArcGISServerLayer(
          this.layer.url + "/" + this.layer.id + "/query?",
          params
        )
          .then((responseCount) => {
            if (
              responseCount.data.hasOwnProperty("error") &&
              responseCount.data.error !== null
            ) {
              resolve({
                items: [],
                total: 0,
              });
            }

            params.params.returnCountOnly = false;
            params.params.resultRecordCount = rowsPerPage;
            params.params.resultOffset = resultOffset;

            if (sortBy !== null) {
              params.params.orderByFields =
                sortBy + " " + (descending ? "DESC" : "ASC");
            }

            TableService.queryArcGISServerLayer(
              this.layer.url + "/" + this.layer.id + "/query?",
              params
            ).then((response) => {
              this.loading = false;
              let items = [];

              response.data.features.forEach((element) => {
                items.push(element);
              });

              resolve({
                items,
                total: responseCount.data.count,
              });
            });
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getQueryParams(layer) {
      let params = {
        params: {
          where: layer.definitionExpression
            ? layer.definitionExpression
            : "1=1",
          outFields: layer.outFields ? layer.outFields.join(",") : "*",
          f: "json",
          outSR: 25833,
          returnCountOnly: true,
        },
      };

      if (this.useMapExtent) {
        params.params.inSR = 25833;
        params.params.spatialRel = "esriSpatialRelIntersects";
        params.params.geometry = this.extent;
      }

      return params;
    },
  },
  watch: {
    pagination: {
      handler() {
        // if (!this.isTable) {
        this.getDataFromApi().then((data) => {
          this.features = data.items;
          this.totalItems = data.total;
        });
        // }
      },
      deep: true,
    },
    extent: function () {
      if (this.useMapExtent) {
        this.getDataFromApi().then((data) => {
          this.features = data.items;
          this.totalItems = data.total;
        });
      }
    },
    useMapExtent: function () {
      this.getDataFromApi().then((data) => {
        this.features = data.items;
        this.totalItems = data.total;
      });
    },
    metadata: function (val) {
      if (val) {
        this.getDataFromApi().then((data) => {
          this.features = data.items;
          this.totalItems = data.total;
        });
      }
    },
    layerInfo: function (val) {
      // if (!this.isTable) {
      this.updateHeaders(val);
      // }
    },
  },
  created() {
    this.$eventHub.$on(
      "layer-filter-set",
      function (layer) {
        if (layer) {
          let parentLayerID = layer.layer.id;
          let layerId = layer.id;

          if (
            this.layer.id == layerId &&
            this.layer.parentLayerID == parentLayerID // HER
          ) {
            this.getDataFromApi().then((data) => {
              this.features = data.items;
              this.totalItems = data.total;
            });
          }
        }
      }.bind(this)
    );
  },
  beforeDestroy() {
    this.$eventHub.$off("layer-filter-set");
  },
  async mounted() {
    this.onResize();
    this.restAdress = this.layer.url.replace(/(^\w+:|^)\/\//, "");
    this.restIndex = this.layer.id;

    if (this.metadata && this.layerInfo) {
      this.updateHeaders(this.layerInfo);
      this.getDataFromApi().then((data) => {
        this.features = data.items;
        this.totalItems = data.total;
      });
    }
    if (!this.metadata) {
      this.loadMetadata({
        restAdress: this.restAdress,
        restIndex: this.restIndex,
      });
    }
    if (!this.layerInfo) {
      await this.loadLayerInfo({
        url: this.layer.url + "/" + this.layer.id,
      });
    }
    this.updateHeaders(this.layerInfo);
  },
};
</script>

<style>
.theme--dark.v-table thead th {
  background-color: #424242;
}
.theme--light.v-table thead th {
  background-color: #fff;
}
/* Theme */
.fixed-header {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.fixed-header th {
  position: sticky;
  top: 0;
  z-index: 5;
}
.fixed-header th:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
}
.fixed-header tr.v-datatable__progress th {
  height: 1px;
}
.fixed-header .v-table__overflow {
  flex-grow: 1;
  flex-shrink: 1;
  overflow-x: auto;
  overflow-y: auto;
}
.fixed-header .v-datatable.v-table {
  flex-grow: 0;
  flex-shrink: 1;
}
.fixed-header .v-datatable.v-table .v-datatable__actions {
  flex-wrap: nowrap;
}
.fixed-header
  .v-datatable.v-table
  .v-datatable__actions
  .v-datatable__actions__pagination {
  white-space: nowrap;
}
</style>
